/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { Path, Svg } from 'react-native-svg'

export const InfoWarning: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <Path d='M12 4L22 21H2L12 4Z' fill='#FF8B1F' />
        <Path
            d='M11.2249 15.4199L10.8344 9.7697H13.1774L12.7869 15.4199H11.2249ZM12.0059 18.5232C11.6532 18.5232 11.3635 18.4119 11.1367 18.1893C10.91 17.9668 10.7966 17.703 10.7966 17.3981C10.7966 17.0848 10.91 16.8252 11.1367 16.6192C11.3635 16.4048 11.6532 16.2977 12.0059 16.2977C12.367 16.2977 12.6567 16.4048 12.8751 16.6192C13.1018 16.8252 13.2152 17.0848 13.2152 17.3981C13.2152 17.703 13.1018 17.9668 12.8751 18.1893C12.6567 18.4119 12.367 18.5232 12.0059 18.5232Z'
            fill='#2B2B2B'
        />
    </Svg>
)
